import React from 'react';

const LoadingDots = () => {
  return (
    <>
      <style>
      {`
        .button-progress-dots {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
        }

        .button-dot {
          width: 6px;
          height: 6px;
          background-color: white;
          border-radius: 50%;
          margin: 0 3px;
        }

        .button-dot:nth-child(1) {
          animation: buttonPulse 1.5s infinite;
        }

        .button-dot:nth-child(2) {
          animation: buttonPulse 1.5s infinite 0.3s;
        }

        .button-dot:nth-child(3) {
          animation: buttonPulse 1.5s infinite 0.6s;
        }

        @keyframes buttonPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.3); opacity: 0.7; }
        }
      `}
      </style>
      <div className="button-progress-dots">
        <div className="button-dot"></div>
        <div className="button-dot"></div>
        <div className="button-dot"></div>
      </div>
    </>
  );
};

export default LoadingDots;